// Imports
import React from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { useAutoplayCarousel } from "@molecules"
import { useSectionHeroData } from "@queries"
import { Section } from "@layout"
import HeroContent from "./hero-content"

export const Hero = () => {
  const { heading01, heading03, cta, ctaLink, rollingText, sliderImages } =
    useSectionHeroData()
  const carousel = useAutoplayCarousel(5000, sliderImages.references)

  return (
    <Section name="hero">
      {carousel}
      <div className="hero-container">
        <div className="hero-container__full-width">
          <HeroContent
            heading01={heading01}
            heading03={heading03}
            cta={cta}
            ctaLink={ctaLink}
            rollingText={rollingText}
            indicator
          />
        </div>
      </div>
      <div className="hero-container__mobile">
        <HeroContent
          heading01={heading01}
          heading03={heading03}
          cta={cta}
          ctaLink={ctaLink}
          rollingText={rollingText}
          logo
        />
      </div>
    </Section>
  )
}
